import videojs from 'video.js';
const Component = videojs.getComponent('Component');
const ClickableComponent = videojs.getComponent('ClickableComponent');

/**
 * The button component for showing feedback form
 *
 * @param {Object} player   Main Player
 * @param {Object=} options Object of option names and values
 * @extends Button
 */
class FeedbackButton extends ClickableComponent {
  constructor(player, options) {
    super(player, options);
    this.controlText(this.localize('Feedback'));
  }

  handleClick() {
    let player = this.player();
    let feedbackForm = player.getChild('feedbackForm');
    if (!feedbackForm) return;
    feedbackForm.hasClass('vjs-hidden') ? feedbackForm.show() : feedbackForm.hide();
  }

  buildCSSClass() {
    return `vjs-feedback-control ${super.buildCSSClass()}`;
  }

  createEl() {
    return super.createEl('div', {
      className: this.buildCSSClass(),
      innerHTML: '<span aria-hidden="true" class="vjs-icon-placeholder"></span>'
    });
  }
}

Component.registerComponent('FeedbackButton', FeedbackButton);
export default FeedbackButton;
